import * as React from 'react';
import { UtilityText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import type { EntityDetail, TranslationObject } from '@web-config-app/core';
import { getLabelText } from '@web-config-app/core-react';
import {
  LinkableCell,
  defaultTextCellCss,
  TableCell,
} from '../table-pieces.component';
import { ValueWithCopyButton } from '../../value-with-copy-button/value-with-copy-button.component';
import { CopyButton } from '../../copy-button/copy-button.component';

export type TextCellProps = {
  item: EntityDetail;
  value: unknown;
  col: {
    id: string;
    label?: TranslationObject;
    copyable?: boolean;
    hideText?: boolean;
  };
  linkTo?: string;
};

export const TextCell: React.FC<TextCellProps> = ({
  item,
  value,
  col,
  linkTo,
}) => {
  const { formatMessage } = useIntl();
  const textCellCss = defaultTextCellCss;
  if (col.copyable) {
    const buttonLabel = formatMessage(
      { id: 'COPY' },
      { title: getLabelText(formatMessage, col.label) },
    );

    // When copyable, do NOT wrap in a link so the copy button is clickable
    return (
      <TableCell css={textCellCss} data-entity-id={item.id}>
        {col.hideText ? (
          <CopyButton
            label={buttonLabel}
            priority="tertiary"
            contents={String(value ?? '')}
            hideLabel
          />
        ) : (
          <ValueWithCopyButton
            value={String(value ?? '')}
            buttonLabel={buttonLabel}
          />
        )}
      </TableCell>
    );
  }

  return (
    <LinkableCell linkTo={linkTo} css={textCellCss} data-entity-id={item.id}>
      <UtilityText>{String(value ?? '')}</UtilityText>
    </LinkableCell>
  );
};
